import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const getPersonalizationBlock = (code, cartId, customerId) => {
  let urlString = '';
  if (cartId) {
    urlString += `&cartId=${cartId}`;
  }
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV1RootUrl()}/personalization-block/code/${code}/for-web?${urlString}`,
    publicAxiosHeader()
  );
};
